export const getOffset = (page: number, productPerPage: number) =>
  btoa(`arrayconnection:${(page - 1) * productPerPage - 1}`);
